import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetcher } from "../api/ApiHook";
import Loader from "../Loader";
import { VERIFY_USER } from "../api/ApiConstants";

const VerifyUser = () => {
  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const VerifingUser = async () => {
    let payload = JSON.stringify({
      token: queryParameters.get("token"),
      email: queryParameters.get("email"),
    });
    try {
      let res = await fetcher(VERIFY_USER, "POST", payload);
      if(res.status) {
        setTimeout(() => {
            navigate('/');
        }, 2000)
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    VerifingUser();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="inc-verify-user">
        <div>Your account verified successfully, Redirecting to the login Page.</div>
      </div>
    </>
  );
};

export default VerifyUser;
